module.exports = __webpack_public_path__ + "static/media/healthy.4233351f.svg";